/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Linesheet_Not_SyncedInputs */

const en_error_linesheet_not_synced = /** @type {(inputs: Error_Linesheet_Not_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The linesheet is not in Business Central yet: send it there first.`)
};

/**
* | output |
* | --- |
* | "The linesheet is not in Business Central yet: send it there first." |
*
* @param {Error_Linesheet_Not_SyncedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_linesheet_not_synced = /** @type {((inputs?: Error_Linesheet_Not_SyncedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Linesheet_Not_SyncedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_linesheet_not_synced(inputs)
});